// extracted by mini-css-extract-plugin
module.exports = {"checksContainer":"CheckList_checksContainer__1l5xY"};